import axios from '../../v2/app/services/axiosService';
import _ from 'lodash';

export default {
  async clone(themeID, name = null) {
    const options = {
      data: {
        name: name,
      }
    };
    const response = await axios.post(`/api/share-themes/${themeID}/clone`, options);
    return response.data;
  },
  async delete(themeID) {
    const response = await axios.delete(`/api/share-themes/${themeID}`);
    return response.data;
  },
  async makeDefault(themeID) {
    const response = await axios.put(`/api/share-themes/${themeID}/default`);
    return response.data;
  },
  async getThemes() {
    const response = await axios.get(`/api/share-themes`);
    return _.orderBy(response.data, ['name'], ['asc']);
  },
  async getDefaultTheme() {
    const response = await axios.get(`/api/share-themes/default`);
    return response.data;
  },
  async getPublicTheme(themeID) {
    const response = await axios.get(`/api/public/share-themes/${themeID}`);
    return response.data;
  },
  async getTheme(themeID) {
    const response = await axios.get(`/api/share-themes/${themeID}`);
    return response.data;
  }
}
